// extracted by mini-css-extract-plugin
export var createdDate = "_kf-1";
export var divider = "_kf-2";
export var headerDivider = "_kf-3";
export var messagesCard = "_kf-0";
export var messagesContainer = "_kf-7";
export var messagesContainerWrapper = "_kf-4";
export var pointerCapturingButtonBoxes = "_kf-a";
export var showLeftPanelButton = "_kf-9";
export var showMoreButton = "_kf-c";
export var showMoreButtonContainer = "_kf-b";
export var summaryTitle = "_kf-6";
export var systemMessageCardWrapper = "_kf-d";
export var topButtons = "_kf-8";
export var withPadding = "_kf-5";